import React from "react";
import Catcher from "./Catcher";
/**
 * Error catcher for all react errors under the tree of this component
 * Will display clean screen versus react error screen
 */
const ErrorCatcher = ({ children, active = true, appName, contactEmail, hasError = false, }) => (React.createElement(React.Fragment, null, active ? (React.createElement(Catcher, { appName: appName, hasError: hasError, contactEmail: contactEmail }, children)) : (children)));
export default ErrorCatcher;
//# sourceMappingURL=ErrorCatcher.js.map